import { render, staticRenderFns } from "./SummaryBtn.vue?vue&type=template&id=519e06c2&scoped=true&"
import script from "./SummaryBtn.vue?vue&type=script&lang=js&"
export * from "./SummaryBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e06c2",
  null
  
)

export default component.exports